// extracted by mini-css-extract-plugin
export default {"addForm":"profile_addForm__eHi78","formControl":"profile_formControl__Za7Mv","list":"profile_list__UTNlX","btnWrpper":"profile_btnWrpper__ilrkM"};